import React from 'react';

import Contacts from './contacts';
import DealField from 'bundles/apex/deals/form/fields/field';

function DealTenants(props) {
  return <Contacts {...props} role="tenant" />;
}

export default DealField(DealTenants, 'tenant');
